import { Button, Col, Divider, Flex, Form, Input, Row, Switch, Table, Upload, message } from 'antd'
import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react'
import VotingEnd from './VotingEnd'
import { InboxOutlined, DeleteOutlined, CheckOutlined, EyeOutlined, DownloadOutlined } from '@ant-design/icons';
import moment from 'moment-timezone';

const { TextArea } = Input;

const { Dragger } = Upload;
const props = {
    name: 'file',
    multiple: true,
    action: 'https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload',
    onChange(info) {
        const { status } = info.file;
        if (status !== 'uploading') {
            console.log(info.file, info.fileList);
        }
        if (status === 'done') {
            message.success(`${info.file.name} file uploaded successfully.`);
        } else if (status === 'error') {
            message.error(`${info.file.name} file upload failed.`);
        }
    },
    onDrop(e) {
        console.log('Dropped files', e.dataTransfer.files);
    },
};

// const dataSource = [
//     {
//         key: '1',
//         attachementName: 'Attachement 1',
//         date: '2024-12-12',
//         action: "",
//         description: " Ad fugiat culpa non amet laborum irure eu. Et laboris Lorem culpa ut duis minim duis sint. Minim magna ad qui voluptate non excepteur ex ipsum irure dolore voluptate est. Sit laborum dolor excepteur ex do. Non officia tempor ipsum aute deserunt in. Nisi do non culpa veniam consequat sint labore id laborum ad sunt."
//     },
//     {
//         key: '2',
//         attachementName: 'Attachement 1',
//         date: '2024-12-12',
//         action: "",
//         description: " Ad fugiat culpa non amet laborum irure eu. Et laboris Lorem culpa ut duis minim duis sint. Minim magna ad qui voluptate non excepteur ex ipsum irure dolore voluptate est. Sit laborum dolor excepteur ex do. Non officia tempor ipsum aute deserunt in. Nisi do non culpa veniam consequat sint labore id laborum ad sunt."
//     },
//     {
//         key: '2',
//         attachementName: 'Attachement 1',
//         date: '2024-12-12',
//         action: "",
//         description: " Ad fugiat culpa non amet laborum irure eu. Et laboris Lorem culpa ut duis minim duis sint. Minim magna ad qui voluptate non excepteur ex ipsum irure dolore voluptate est. Sit laborum dolor excepteur ex do. Non officia tempor ipsum aute deserunt in. Nisi do non culpa veniam consequat sint labore id laborum ad sunt."
//     },
// ];

const AddAgendaItem = forwardRef((props, ref) => {
    const [form] = Form.useForm();

    const [attachmentName, setAttachmentName] = useState("");
    const [attachement, setAttachement] = useState([]);
    const [addedDocTableData, setAddedDocTableData] = useState([])

    useImperativeHandle(ref, () => ({
        validateAndRetrieveData: async () => {
            try {
                const values = await form.validateFields();
                return values;
            } catch (error) {
                // console.log("error in agenda :", error);
                throw error;
            }
        },
        resetFormFields: () => {
            form.resetFields();
            props.setAttachement([]);
            setAttachement([]);
            setAddedDocTableData([]);
            props.setAllowVoting(false);
        },
    }))

    const handleUpload = (e) => {
        if (!attachmentName) {
            form.setFields([
                {
                    name: 'attachmentName',
                    errors: ['Please enter an attachment name.']
                }
            ])
        }
        else {
            const randomId = Math.random().toString(36).substr(2, 9);
            props.setAttachement(prev => [
                ...prev,
                {
                    id: randomId,
                    name: attachmentName,
                    file: "test file",
                    created: moment().format('YYYY-MM-DD')
                }
            ]);

            setAttachement(prev => [
                ...prev,
                {
                    id: randomId,
                    name: attachmentName,
                    file: "test file",
                    created: moment().format('YYYY-MM-DD')
                }
            ])
            // Clear the form field and state after upload finishes
            form.resetFields(['attachmentName']);
            setAttachmentName('');
        }
    }

    const handleVotingSwitch = (checked) => {
        props.setAllowVoting(checked);
    }

    const handleRemoveAttachment = (record) => {
        const filteredArray = attachement.filter(item => item.id !== record.id);
        const filteredPropsArray = props.attachement.filter(item => item.id !== record.id);
        setAttachement(filteredArray)
        props.setAttachement(filteredPropsArray)
    }

    useEffect(() => {
        const updatedTableData = attachement.map((item, index) => ({
            key: index,
            id: item.id,
            attachementName: item.name,
            date: item.created
        }));
        setAddedDocTableData(updatedTableData);
    }, [attachement]);

    const columns = [
        {
            title: 'Attachment Name',
            dataIndex: 'attachementName',
            key: 'attachementName',
        },
        {
            title: 'Created',
            dataIndex: 'date',
            key: 'date',
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            align: 'center',
            render: (_, record) => (
                <Flex gap="small" justify="center" align="center" vertical>
                    <Flex gap="middle" wrap="wrap">
                        <Button icon={<EyeOutlined />} size='small' />
                        <Button type="primary" icon={<DownloadOutlined />} size='small' />
                        {/* <Button type="primary" icon={<EditOutlined />} size='small' /> */}
                        <Button danger type="primary" icon={<DeleteOutlined />} size='small' onClick={() => handleRemoveAttachment(record)} />
                    </Flex>
                </Flex>
            ),
        }
    ];

    return (
        <Form layout="vertical" form={form}>
            <Col span={24}>
                <Form.Item label="Agenda Item" name="agendaItem" rules={[{ required: true, message: 'Please enter the agenda item' }]}>
                    <Input />
                </Form.Item>
            </Col>
            <Col span={24}>
                <Form.Item label="Description" name="description" >
                    <TextArea />
                </Form.Item>
            </Col>
            <Col span={24}>
                <Divider>Add Items</Divider>
            </Col>
            <Col span={24}>
                <Form.Item label="Attachment Name" name="attachmentName">
                    <Input onChange={(e) => {
                        setAttachmentName(e.target.value);
                        form.setFields([
                            {
                                name: 'attachmentName',
                                errors: [] // Clear the error message when starts typing
                            }
                        ])
                    }} />
                </Form.Item>
            </Col>
            <Col span={24}>
                <Form.Item label="Document" name="document">
                    <Dragger {...props}>
                        <p className="ant-upload-drag-icon">
                            <InboxOutlined />
                        </p>
                        <p className="ant-upload-text">Click or drag file to this area to upload</p>
                        {/* <p className="ant-upload-hint">
                                    Support for a single or bulk upload. Strictly prohibited from uploading company data or other
                                    banned files.
                                </p> */}
                    </Dragger>
                </Form.Item>
            </Col>
            <Col span={24} style={{ marginBottom: 24 }}>
                <Flex align='center' justify='flex-end'>
                    <Button type="primary" onClick={(e) => { handleUpload(e) }}>
                        Upload
                    </Button>
                </Flex>
            </Col>
            <Col span={24}>
                <Table
                    dataSource={addedDocTableData}
                    columns={columns}
                    title={() => 'Added Documents'}
                />
            </Col>


            <Col span={24}>
                <Form.Item >
                    <p>Allow Voting <Switch size='small' onChange={handleVotingSwitch} checked={props.allowVoting} /></p>
                    {props.allowVoting && (<div>
                        <Row>
                            <Col span={12}>
                                <Form.Item label="Voting Ends">
                                    <VotingEnd setVotingData={props.setVotingData} />
                                </Form.Item>
                            </Col>
                        </Row>
                    </div>)}
                </Form.Item>
            </Col>
        </Form>
    )
});

export default AddAgendaItem;
